<template>
    <section class="section-contacts-options" v-bind:class="'section-contacts-options--' + type">
        <div class="container">
            <h3 class="title" v-html="title"></h3>
            <ul>
                <li v-for="item in list">
                    <a :href="item.url" :target="item.target || ''">
                        <span v-html="item.icon"></span>
                        {{ item.title }}
                    </a>
                </li>
            </ul>
        </div>
    </section>
</template>

<style lang="scss">
    .section-contacts-options--gray-style {
        svg path {
            fill: var(--color-purple-darker);
        }
    }
</style>

<style lang="scss" scoped>
    .section-contacts-options {
        position: relative;
        padding: 50px 0;
        background-color: #C624ED;
        background: linear-gradient(90deg, #C624ED 25%, #FF5E99 100%);
        color: #FFFFFF;
        text-align: center;
        margin-top: 80px;
        z-index: 1;
        overflow: hidden;

        &--gray-style {
            background: var(--color-gray-light);

            &::before,
            &::after {
                display: none;
            }

            li a,
            .title {
                color: var(--color-purple-darker);
            }
        }

        &::before,
        &::after {
            content: '';
            position: absolute;
            background-repeat: no-repeat;
            z-index: -1;
        }

        &::before {
            top: 0;
            left: 0;
            width: 120%;
            height: 100%;
            background-image: url('/images/backgrounds/background-arco.png');
            background-size: contain;
            background-position: left bottom;
        }

        &::after {
            bottom: -1%;
            right: 5%;
            width: 75px;
            height: 160px;
            background-image: url('data:image/png;base64,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');
            background-size: cover;
        }

        .container {
            max-width: 100%;
        }

        .only-desktop {
            display: none;
        }

        .title {
            font-size: 31px;
            line-height: 1.1;
            margin-bottom: 50px;
        }

        @media (min-width: 730px) {
            padding: 100px 0;

            &::before {
                width: 100%;
            }

            &::after {
                top: 15%;
                bottom: inherit;
            }

            .only-desktop {
                display: inline-block;
            }

            .title {
                font-size: 38px;
            }
        }

        a {
            color: #FFFFFF;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        ul {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            list-style: none;
            padding: 0;
            margin: 0;

            @media (max-width: 730px) {
                justify-content: space-between;
            }

            li {
                width: 30%;
                max-width: 140px;
                font-size: 16px;
                font-weight: 600;

                @media (min-width: 730px) {
                    max-width: 170px;
                    font-size: 20px;
                }
            }

            span {
                display: block;
                text-align: center;
                min-width: 30px;
                min-height: 30px;

                & svg {
                    height: 30px;
                    width: 30px;
                }
            }
        }
    }
</style>

<script>
    export default {
        props: {
            type: String,
            title: {
                type: String,
                required: true,
            },
            list: {
                type: Array,
                required: true,
            },
        },
    }
</script>
